// usersData.js
const usersData = [
  {
    id: "#87234",
    name: "Name here",
    email: "Email@gmail.com",
    phone: "+923227272728",
    active: true,
  },
  {
    id: "#87235",
    name: "Name here",
    email: "Email@gmail.com",
    phone: "+923227272728",
    active: true,
  },
  {
    id: "#87236",
    name: "Name here",
    email: "Email@gmail.com",
    phone: "+923227272728",
    active: true,
  },
  {
    id: "#87237",
    name: "Name here",
    email: "Email@gmail.com",
    phone: "+923227272728",
    active: false,
  },
  {
    id: "#87238",
    name: "Name here",
    email: "Email@gmail.com",
    phone: "+923227272728",
    active: true,
  },
  {
    id: "#87239",
    name: "Name here",
    email: "Email@gmail.com",
    phone: "+923227272728",
    active: true,
  },
  {
    id: "#87240",
    name: "Name here",
    email: "Email@gmail.com",
    phone: "+923227272728",
    active: true,
  },
];

export default usersData;
